import React from 'react';
import { Container } from './ui/Container';
export function Footer() {
  return <footer className="bg-white text-[#2D2D2D] py-12 border-t border-[#E5E5E0]" data-id="element-1">
      <Container data-id="element-2">
        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-3">
          <div className="col-span-1 md:col-span-2" data-id="element-4">
            <div className="flex items-center gap-4 mb-4" data-id="element-5">
              <img src="https://cdn.magicpatterns.com/uploads/hfTK3ieARsQcNyRbuf5Nbs/Good_Father_Project.png" alt="The Good Father Project" className="h-10 w-auto" data-id="element-6" />
              <img src="https://cdn.magicpatterns.com/uploads/oBYX1NT7UPNdf2Ei2CE3Fy/Fatherhood_Initiative.png" alt="Fatherhood Initiative" className="h-12 w-auto" data-id="element-7" />
            </div>
            <p className="text-[#666666] max-w-sm leading-relaxed" data-id="element-8">
              Strengthening families through reflection, presence, and community
              partnership. An initiative dedicated to the quiet, vital work of
              fatherhood.
            </p>
          </div>

          <div data-id="element-9">
            <h4 className="text-[#2D2D2D] font-medium mb-4 uppercase tracking-wider text-sm" data-id="element-10">
              Navigation
            </h4>
            <ul className="space-y-3" data-id="element-11">
              <li data-id="element-12">
                <a href="#mission" className="text-[#666666] hover:text-[#3D5A4C] transition-colors" data-id="element-13">
                  Mission
                </a>
              </li>
              <li data-id="element-14">
                <a href="#how-it-works" className="text-[#666666] hover:text-[#3D5A4C] transition-colors" data-id="element-15">
                  How It Works
                </a>
              </li>
              <li data-id="element-16">
                <a href="#who-its-for" className="text-[#666666] hover:text-[#3D5A4C] transition-colors" data-id="element-17">
                  Who It's For
                </a>
              </li>
              <li data-id="element-18">
                <a href="#partner" className="text-[#666666] hover:text-[#3D5A4C] transition-colors" data-id="element-19">
                  Partner With Us
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-20">
            <h4 className="text-[#2D2D2D] font-medium mb-4 uppercase tracking-wider text-sm" data-id="element-21">
              Contact
            </h4>
            <p className="text-[#666666]" data-id="element-22">info@goodfatherproject.org</p>
          </div>
        </div>

        <div className="pt-8 border-t border-[#E5E5E0] flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-[#999999]" data-id="element-23">
          <p data-id="element-24">
            &copy; {new Date().getFullYear()} The Good Father Project. All
            rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-25">
            <a href="#" className="hover:text-[#3D5A4C] transition-colors" data-id="element-26">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-[#3D5A4C] transition-colors" data-id="element-27">
              Terms of Service
            </a>
          </div>
        </div>
      </Container>
    </footer>;
}